import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { closeImg } from '../UI/Icons'
import Button from './Button'
import { useSelector } from 'react-redux';
import parse from 'html-react-parser';
import './UI.css'

function ConsentDialog({ handleClose, handleAccept, consentData, consentFormData }) {
    const isMobile = useSelector(state => state.home.isMobileDev);

    const btnData = {
        btnName: consentFormData.button
    }

    function ConsentContent() {
        const content = [];
        for (const key in consentData) {
            if (key.includes("Heading")) {
                // Render headings for properties containing "Heading"
                content.push(<h4 key={key} style={{ marginTop: 5, marginBottom: 5 }}>{parse(consentData[key])}</h4>);
            } else {
                // Render divs for other properties
                content.push(<div key={key} className="consent-text" >{parse(consentData[key])}</div>);
            }
        }

        return <div>{content}</div>;
    }

    return (
        <Dialog open={true} onClose={handleClose} maxWidth="lg">
            <div style={{
                background: '#D9D9D9',
                padding: isMobile ? 18 : 24
            }}>
                {/* <div
                    onClick={() => { handleClose() }}
                    style={{
                        float: 'right',
                        cursor: 'pointer'
                    }}
                >
                    <img src={closeImg} alt="closeImg" style={{ width: isMobile ? 16 : 30 }} />
                </div> */}
                <DialogTitle sx={{
                    color: '#000080', fontWeight: 600, textAlign: 'left',
                    fontSize: isMobile ? 16 : 'inherit',
                    padding: 0
                }}
                >
                    {consentFormData.heading}
                </DialogTitle>
                <div style={{
                    textAlign: isMobile ? 'left' : 'left',
                    // fontSize: isMobile ? 14 : 'inherit',
                }}>
                    {parse(consentFormData.subHeading)}</div>
                <DialogContent sx={{
                    background: 'white',
                    padding: isMobile ? 0 : '5px',
                    margin: '10px 0px'
                }}>
                    <DialogContentText
                        sx={{
                            maxHeight: isMobile ? 'calc(100vh - 280px)' : 'calc(100vh - 300px)',
                            overflow: 'auto',
                            letterSpacing: isMobile ? 0 : 'inherit',
                            padding: 1,
                            // fontSize: isMobile ? 14 : 'inherit',
                        }}
                    >
                        {ConsentContent()}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: 0, position: 'sticky', bottom: 0,  borderTop: '1px solid #ddd',
      background: '#D9D9D9', }}>
                    <Button handleBtnClick={handleAccept} btnData={btnData} />
                </DialogActions>
            </div>
        </ Dialog>
    );
}

export default ConsentDialog;
